// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-PageSubheader-PageSubheader-module__box--oholu {
  display: flex;
  flex-direction: row;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;
  border-bottom: #f0f0f0 1px solid;
}
.src-components-PageSubheader-PageSubheader-module__title--mWlXH {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
/*# sourceMappingURL=PageSubheader.module.css.map */`, "",{"version":3,"sources":["webpack://./PageSubheader.module.less","webpack://./src/components/PageSubheader/PageSubheader.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;ACCF;ADEA;EACE,OAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;AACA,mDAAmD","sourcesContent":[".box {\n  display: flex;\n  flex-direction: row;\n  padding: 12px 16px;\n  align-items: center;\n  gap: 8px;\n  border-bottom: rgba(240, 240, 240, 1) 1px solid;\n}\n\n.title {\n  flex: 1;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n}\n",".box {\n  display: flex;\n  flex-direction: row;\n  padding: 12px 16px;\n  align-items: center;\n  gap: 8px;\n  border-bottom: #f0f0f0 1px solid;\n}\n.title {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n}\n/*# sourceMappingURL=PageSubheader.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-PageSubheader-PageSubheader-module__box--oholu`;
export var title = `src-components-PageSubheader-PageSubheader-module__title--mWlXH`;
export default ___CSS_LOADER_EXPORT___;
